import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { DS } from '../../components/ds';
import { BlogContextProvider } from '../../contexts/BlogContext';
import { ArticleList } from '../../components/sections/blog/ArticleList';
import { BlogBreadcrumb } from '../../components/sections/blog/BlogBreadcrumb';
import type { BlogArticle } from '../../data/blogArticles';
function BlogPageContent() {
  const navigate = useNavigate();
  const goToArticle = (article: BlogArticle) => {
    navigate(`/blog/${article.id}`);
  };
  return <section style={{
    background: '#fff',
    minHeight: '100vh',
    paddingTop: '68px'
  }} data-id="element-879" data-mp="2lojwkqd7s5ik">
      <BlogBreadcrumb items={[{
      label: 'Alinova',
      to: '/'
    }, {
      label: 'Blog'
    }]} data-id="element-880" data-mp="2gph2g0yrvjpd" />

      <div style={{
      position: 'relative',
      padding: '56px 24px',
      background: 'linear-gradient(135deg, rgba(0,170,212,0.08) 0%, rgba(45,212,212,0.05) 100%)',
      borderBottom: `1px solid ${DS.color.border}`,
      overflow: 'hidden'
    }} data-id="element-881" data-mp="2gncqcvqpzee0">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative'
      }} data-id="element-882" data-mp="3ezzt265g087a">
          <button type="button" onClick={() => navigate('/')} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: 'transparent',
          border: 'none',
          padding: 0,
          marginBottom: '24px',
          color: DS.color.teal,
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          cursor: 'pointer'
        }} data-id="element-883" data-mp="30b3qupq2hpel">
            <ArrowLeftIcon size={16} aria-hidden="true" data-id="element-884" data-mp="3nzmtaomfr7yr" />
            Volver al inicio
          </button>

          <h1 style={{
          fontFamily: DS.font.heading,
          fontSize: 'clamp(2.2rem, 5vw, 3rem)',
          fontWeight: 700,
          color: DS.color.ink,
          letterSpacing: '-0.03em',
          lineHeight: 1.1,
          margin: '0 0 14px'
        }} data-id="element-885" data-mp="28j4mbeyv1eac">
            Alinova Blog
          </h1>
          <p style={{
          fontFamily: DS.font.body,
          fontSize: '17px',
          color: DS.color.body,
          maxWidth: '520px',
          margin: 0
        }} data-id="element-886" data-mp="9ch2ic3c1h7t">
            Conocimiento clínico, tendencias y mejores prácticas en
            ortodoncia invisible.
          </p>
        </div>
      </div>

      <div style={{
      padding: '56px 24px 80px'
    }} data-id="element-887" data-mp="3rkygzp0dr2p6">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }} data-id="element-888" data-mp="3mkk4nurqx6lc">
          <ArticleList onSelectArticle={goToArticle} data-id="element-889" data-mp="3hko1tyusbl7d" />
        </div>
      </div>
    </section>;
}
export function BlogPage() {
  return <BlogContextProvider data-id="element-890" data-mp="1kquo1aam5kko">
      <BlogPageContent data-id="element-891" data-mp="1krcq4njyit0i" />
    </BlogContextProvider>;
}